// @ts-nocheck
import { ENV } from '$lib/conf'
import App from './App.svelte'
import './app.css'

if (!ENV.DEV) {
    const nop = (_) => _
    console = {
        log: nop,
        warning: nop,
        warn: nop,
        error: nop,
    }
}
const app = new App({
    target: document.body,
})

export default app
